import React, { useState, useEffect } from 'react';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import axios from 'axios';
import config from '../../../config/config.json';
import Pdf from '../Hurricanes/Pdf';

const useStyles = makeStyles((theme) => ({
    pvrsWrapper: {
        height: window.screen.availHeight / 2,
        marginBottom: theme.spacing(2),
    },
    pvr: {
        height: '100%',
        width: '100%',
    },
}));

export default function (props) {
    const classes = useStyles();

    const [pvrs, setPvrs] = useState([]);

    useEffect(() => {
        // effect
        const url = `${config.apiBaseUrl}/pvr`;

        async function fetchPvrs() {
            let response = await axios.get(url);
            console.log(response.data);
            setPvrs(response.data);
        }
        fetchPvrs();

        return () => {
            // cleanup
        }
    }, [])

    return (
        <main style={{ paddingTop: 88 }}>
            <div className="heading">
                <Typography variant="h4" color="initial" className="efecto-espejo" style={{ marginBottom: 10 }}>
                    Peligro Vulnerabilidad & Riesgo
                </Typography>
            </div>

            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
                alignContent="center"
            // wrap="nowrap"

            >
                {
                    pvrs.map((pvr, index) => {
                        return (
                            <Grid item md={5} sm={10}>
                                <Typography variant="h6" color="initial">
                                    {pvr.peligro}
                                </Typography>
                                <div className={classes.pvrsWrapper} id="pvrsWrapper">
                                    <iframe src={pvr.documento} title={pvr.documento} frameborder="0" className={classes.pvr}></iframe>
                                    {/* <Pdf src={pvr.documento} /> */}
                                </div>
                            </Grid>
                        )
                    })

                }

            </Grid>
        </main>
    )
}